/* Catwood v4: product carousel + search suggestions. Upload to assets/catwood-v4.js */
(function () {
  if (window.__cwhV4) return; window.__cwhV4 = true;
  function pad(n) { return ('0' + n).slice(-2); }
  function initCarousel(root) {
    var slides = [].slice.call(root.querySelectorAll('.hc-slide'));
    var dots = [].slice.call(root.querySelectorAll('.hc-dot'));
    var cnt = root.querySelector('.hc-count');
    root.setAttribute('data-n', slides.length);
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce) and (max-width: 0px)').matches;
    root.className += ' js';
    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === i); s.setAttribute('aria-hidden', k === i ? 'false' : 'true'); });
      dots.forEach(function (d, k) { d.classList.toggle('on', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      if (cnt) cnt.textContent = pad(i + 1) + ' / ' + pad(slides.length);
    }
    function stop() { clearInterval(timer); }
    function play() { stop(); if (!reduce) timer = setInterval(function () { show(i + 1); }, 5000); }
    root.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-hc]') : null;
      if (!b || !root.contains(b)) return;
      var a = b.getAttribute('data-hc');
      if (a === 'next') show(i + 1); else if (a === 'prev') show(i - 1); else show(parseInt(a, 10));
      play();
    });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', play);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', play);
    var x0 = null;
    root.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    root.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) show(i + (dx < 0 ? 1 : -1));
      play();
    }, { passive: true });
    show(0); play();
  }
  function initSearch(form) {
    var input = form.querySelector('input[type="search"]');
    var items = [].slice.call(form.querySelectorAll('.sr[data-t]'));
    var none = form.querySelector('.sr-none');
    if (!input) return;
    function filter() {
      var q = input.value.trim().toLowerCase(), shown = 0;
      items.forEach(function (a) {
        var ok = !q || a.getAttribute('data-t').indexOf(q) > -1;
        a.hidden = !ok; if (ok) shown++;
      });
      if (none) none.hidden = shown > 0;
    }
    input.addEventListener('input', filter);
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') input.blur(); });
    filter();
  }
  function ready() {
    [].forEach.call(document.querySelectorAll('.hc'), initCarousel);
    [].forEach.call(document.querySelectorAll('.cwh-search'), initSearch);
  }
  if (document.readyState !== 'loading') ready(); else document.addEventListener('DOMContentLoaded', ready);
})();